// extracted by mini-css-extract-plugin
export default {"deposit-button":"depositButton_deposit-button__lOCgP","header-deposit-btn":"depositButton_header-deposit-btn__MZbm2"};